// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"d28b99f45cfec044d74f","691":"6fab6ea173cbd3590e74"}[chunkId] + ".js";
};